import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const FadeUp = ({ children, delay = 0, className, y = 40, ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

const line = { hidden: { y: "112%" }, show: ({ i, d }) => ({ y: "0%", transition: { duration: 1.15, ease: EASE, delay: d + i * 0.12 } }) };

// Masked line-by-line reveal; observer sits on the unclipped wrapper.
export const MaskLines = ({ lines, className = "", lineClassName = "", onLoad = false, delay = 0 }) => (
  <motion.span
    className={`block ${className}`}
    initial="hidden"
    {...(onLoad ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.1 } })}
  >
    {lines.map((l, i) => (
      <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
        <motion.span className={`block ${lineClassName}`} variants={line} custom={{ i, d: delay }}>
          {l}
        </motion.span>
      </span>
    ))}
  </motion.span>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`font-cinzel uppercase text-[11px] sm:text-xs tracking-[0.32em] text-[#D4AF37] ${className}`}>{children}</p>
);
